import type { DiffValue } from "@shared/roi/diff";
import { formatCount, formatMoney, formatPercent } from "@shared/roi/format";

/** The one place a `DiffValue` becomes text. The diff itself stays currency-free. */
export function formatDiffValue(value: DiffValue, currencyCode: string): string {
  switch (value.kind) {
    case "absent":
      return "—";
    case "money":
      return formatMoney(currencyCode, Number(value.value));
    case "percent":
      return formatPercent(Number(value.value));
    case "count":
      return formatCount(Number(value.value));
    case "units":
      return String(value.value);
    case "years": {
      const years = Number(value.value);
      return years === 1 ? "1 year" : `${years} years`;
    }
    case "year":
      return `Year ${value.value}`;
    case "boolean":
      return value.value ? "Yes" : "No";
    case "text":
      return value.value === null || value.value === "" ? "—" : String(value.value);
    case "label":
      return String(value.value);
  }
}
